import { AuthService } from './../../Services/auth.service';
import { SubscriptionService } from './../../Services/subscription.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { PaymentService } from '../../Services/payment.service';
// import { moduleHasNonRelativeName } from 'typescript';
// import { KeyEventsPlugin } from '@angular/platform-browser/src/dom/events/key_events';
// import { _localeFactory } from '@angular/core/src/application_module';

@Component({
  selector: 'app-subscription-activities-member',
  template: require('./subscription-activities-member.component.html'),
  styles: [require('./subscription-activities-member.component.css')]
})
export class SubscriptionActivitiesMemberComponent implements OnInit {
  Subscriptions: any = [];
  mySubs:any = [];
  memberId:number = 0;

  constructor(  private route: ActivatedRoute, 
                private subscriptionService: SubscriptionService, 
                private auth: AuthService,
                private paymentService: PaymentService,
                private router: Router ) {
    
    route.params.subscribe(p => {
      if (p['id'])
        this.memberId = +p['id'];
      else
        this.memberId = 0;
    });

    (window as any).Swal = Swal;
  }

  

  ngOnInit() {
    this.refreshMySubscriptions()
  }

  getAllOpenSubscriptions(){
    this.subscriptionService.getOpenSubscriptions(this.memberId).subscribe(x => {
      this.Subscriptions = x;  
      this.getMySubscriptions(); 
    })
  }

  getMySubscriptions(){     
    this.subscriptionService.getMySubscriptions(this.memberId).subscribe( mySubs => {
      this.mySubs = mySubs
      
      var alreadyProcessed:number[] = [];

      this.Subscriptions.forEach((s:any) => {
        var f = mySubs.find( (ms:any) => ms.subscriptionId == s.id )
        s.hasPayedDeposit = false;
        s.hasPayedFull = false;
        s.isSubscribed = false;
        if (f){
          s.hasPayedDeposit = f.hasPayedDeposit;
          s.hasPayedFull = f.hasPayedFull;
          s.isSubscribed = f.isSubscribed;
          s.extras = f.extras;
          s.extraNames = f.extraNames;
          s.singleRoom = f.singleRoom;
          s.kindOfBikes = f.kindOfBikes;
          s.amountOfNonStdBikes = f.amountOfNonStdBikes;
          s.remarks = f.remarks;
          s.personalTransport = f.personalTransport;
          alreadyProcessed.push(f.subscriptionId)
        }   
      });
      mySubs.forEach((ms:any) => {
        var i = alreadyProcessed.find( apitem => apitem == ms.subscriptionId)
        if (!i){
          ms.subscription.isSubscribed = ms.isSubscribed;
          ms.subscription.hasPayedDeposit = ms.hasPayedDeposit;
          ms.subscription.hasPayedFull = ms.hasPayedFull;
          ms.subscription.extras = ms.extras;
          ms.subscription.extraNames = ms.extraNames;
          ms.subscription.singleRoom = ms.singleRoom;
          ms.subscription.personalTransport = ms.personalTransport;
          if (ms.subscription.allowRemarks){
            ms.subscription.remarks = ms.remarks;
          }else{
            ms.subscription.remarks = "";
          }
          this.Subscriptions.push(ms.subscription);
        }
      });   
    })    
  }

  async subscribe(activity_id:number){
    var i = this.mySubs.find( (s:any) => s.subscriptionId == activity_id)
    var selectedActivity = this.Subscriptions.find( (s:any)=>s.id == activity_id)

    if (i){
      this.changeSubscription(activity_id)
    }else{
      // console.log(selectedActivity);
      
      if (selectedActivity){
        if (selectedActivity.openForNonMembers){

          var html = `<div style="text-align:left">
                        <div class="row mt-4">
                          <div class="col col-lg-2">
                            <input class="form-control" type="checkbox" id="extrasCheck" name="extrasCheck" value="false" onchange="(function(){ 
                                var extras = document.getElementById('ExtraPeopleInformation')
                                
                                var checkbox = document.getElementById('extrasCheck');
                                
                                switch (checkbox.checked) {
                                    case true:
                                        extras.style.display = 'inline'
                                        break;
                                    case false:
                                        extras.style.display = 'none'
                                        break;
                                    default:
                                        break;
                                }
                              })()" />
                          </div>
                          <div class="col col-lg-10">
                            <label class="control-label" for="extrasCheck">Ik breng nog een <strong>niet</strong> lid mee</label>
                          </div>
                        </div>
                        
                        <span id="ExtraPeopleInformation" style="display: none;">
                          <div class="row mt-2">
                            <div class="col col-lg-12">
                              Als je niet leden meebrengt vul dan het aantal en de namen in de onderstaande velden in.<br><br>
                              
                              bv:<br>
                              Breng je 1 niet-lid extra mee, vul dan 1 in. <br><br>

                              Best is ook dat elk lid zich afzonderlijk inschrijft <br><br>
                              
                            </div>
                          </div>
                        
                          <div class="row mt-4">
                            <div class="col col-lg-4">
                              <label class="control-label"  for="input1">Aantal niet leden:</label>
                            </div>
                            <div class="col col-lg-8">
                              <input class="form-control" type="number" id="input1" min=0 value=0>
                            </div>
                          </div>
  
                          <div class="row mt-2">
                            <div class="col col-lg-4">
                              <label class="control-label"  for="input1">Namen niet leden:</label>
                            </div>
                            <div class="col col-lg-8">
                              <textarea class="form-control mt-3" id="input2" rows=5></textarea>
                            </div>
                          </div>
                        </span>
                        
                        `
          
          if (selectedActivity.singleRoomAvailable){
            html += `<div class="row mt-4">
                          <div class="col col-lg-2">
                            <input class="form-control" type="checkbox" id="input3">
                          </div>
                          <div class="col col-lg-10">
                            <label class="control-label"  for="input3">Ik wil een 1-persoonskamer.</label>
                          </div>
                        </div>
                      `
          }    
          
          if (selectedActivity.openForPersonalTransport){
            html += `<div class="row mt-4">
                          <div class="col col-lg-2">
                            <input class="form-control" type="checkbox" id="input4">
                          </div>
                          <div class="col col-lg-10">
                            <label class="control-label"  for="input4">Ik gebruik eigen vervoer.</label>
                          </div>
                        </div>
                      `
          } 

          if(selectedActivity.extraQuestion){
            html += `<div class="row mt-4">
                          <div class="col col-lg-2">
                            <input class="form-control" type="checkbox" id="input5">
                          </div>
                          <div class="col col-lg-10">
                            <label class="control-label"  for="input5">${selectedActivity.extraQuestionText}</label>
                          </div>
                        </div>
                      `
          }
          



          Swal.fire({
            // showCancelButton: true,
            // cancelButtonColor: '#d33',
            // cancelButtonText: 'Annuleren',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Volgende',
            title: 'Extra vragen.',
            width: '600px',
            html:  html,
            preConfirm:function(result){
                          if(result){
                            // var amount = parseInt( ($('#input1').val()as string));
                            // var amount = parseInt( ($('#input1').val()as HTMLInputElement).value);
                            var amount = parseInt( String($('#input1').val()) )
                            
                            var names = $('#input2').val();
                            var singleRoom = $('#input3').is(':checked');
                            var personalTransport = $('#input4').is(':checked');
                            var extraQuestionResponse = $('#input5').is(':checked');
                            if (!amount){
                                amount = 0                                                                   
                            }

                            return {Extras:amount, ExtraNames:names, SingleRoom: singleRoom, PersonalTransport:personalTransport, ExtraQuestionResponse: extraQuestionResponse}  
                          }
                        }
                    }).then( async (res:any)=>{
                      // console.log("res in [breng je niet leden mee]: ",res);
                      
                      // -------------------Non Std Bikes--------------------------------------------------------------------


                      if(selectedActivity.openForNonRaceBikes){
                        var html = `<div style="text-align:left">

                                      <div class="row">
                                        <div class="col col-lg-2">
                                          <input class="form-control" type="checkbox" id="extrasBikesCheck" name="extrasBikesCheck" value="false" onchange="(function(){ 
                                              var extraBikes = document.getElementById('ExtraBikeInformation')
                                              
                                              var checkbox = document.getElementById('extrasBikesCheck');
                                              
                                              switch (checkbox.checked) {
                                                  case true:
                                                      extraBikes.style.display = 'inline'
                                                      break;
                                                  case false:
                                                      extraBikes.style.display = 'none'
                                                      break;
                                                  default:
                                                      break;
                                              }
                                            })()" />
                                        </div>
                                        <div class="col col-lg-10">
                                          <label class="control-label" for="extrasBikeCheck">Ik breng een <strong>niet</strong> standard koersfiets mee</label>
                                        </div>
                                      </div>
                                      <span id="ExtraBikeInformation" style="display: none;">

                                          <div class="row mt-4">
                                            <div class="col col-lg-12">
                                              Als je een MTB of electrische fiets meebrengt vul dan onderstaande velden in.<br><br>
                                            </div>
                                          </div>
                                          <div class="row mt-4">
                                            <div class="col col-lg-4">
                                              <label class="control-label"  for="input1">Aantal:</label>
                                            </div>
                                            <div class="col col-lg-8">
                                              <input class="form-control" type="number" id="input1">
                                            </div>
                                          </div>
                                          <div class="row mt-4">
                                            <div class="col col-lg-4">
                                              <label class="control-label"  for="input1">Welke fietsen:</label>
                                            </div>
                                            <div class="col col-lg-8">
                                              <textarea class="form-control mt-3" id="input2" rows=5></textarea>
                                            </div>
                                          </div>
                                      </span>
                        `
  
                        await Swal.fire({
                          title: 'Breng je extra fietsen mee?',
                          html: html,
                          type: 'question',
                          width: '600px',
                          confirmButtonColor: '#3085d6',
                          confirmButtonText: 'Volgende',
                          // showCancelButton: true,
                          // cancelButtonColor: '#d33',
                          // cancelButtonText: 'Nope',
                          preConfirm:function(result){
                            if(result){
                              // var amountofBikes = parseInt( ($('#input1').val()as string));
                              // var amountofBikes = parseInt( ($('#input1').val()as HTMLInputElement).value);
                              
                              var amountofBikes = parseInt( String($('#input1').val()) )
 
                              var kindofBikes = $('#input2').val();
                              if (!amountofBikes){
                                amountofBikes = 0                                                                   
                              }
                              return {AmountOfNonStdBikes:amountofBikes, KindOfBikes:kindofBikes}  
                            }
                          }
                        }).then((result) => {
                            // console.log("Result in [breng je extra fietsen mee]", result);
                            // console.log("res before : ",res);
  
                            var temp = { value:{}}
                            temp.value = {...res.value,...result.value, AllowRemarks:selectedActivity.allowRemarks}
                            res.value = temp.value;
  
                            // console.log("res to send : ",res);
                        });
                      }
                      // --------------------Non Std Bikes-------------------------------------------------------------------

                      if (res.value){
                        this.changeSubscription(activity_id, res.value);
                      }
                    })
          
        }else{
          // console.log("In de else: ");

          // ------------------------------- Non Std Bikes -----------------------------------------------------
          if(selectedActivity.openForNonRaceBikes){
            var html = `<div style="text-align:left">
                          <div class="row">
                          <div class="col col-lg-2">
                            <input class="form-control" type="checkbox" id="extrasBikesCheck" name="extrasBikesCheck" value="false" onchange="(function(){ 
                                var extraBikes = document.getElementById('ExtraBikeInformation')
                                
                                var checkbox = document.getElementById('extrasBikesCheck');
                                
                                switch (checkbox.checked) {
                                    case true:
                                        extraBikes.style.display = 'inline'
                                        break;
                                    case false:
                                        extraBikes.style.display = 'none'
                                        break;
                                    default:
                                        break;
                                }
                              })()" />
                          </div>
                          <div class="col col-lg-10">
                            <label class="control-label" for="extrasBikeCheck">Ik breng een <strong>niet</strong> standard koersfiets mee</label>
                          </div>
                        </div>

             <span id="ExtraBikeInformation" style="display: none;">
                <div class="row mt-4">
                  <div class="col col-lg-12">
                    Als je een MTB of electrische fiets meebrengt vul dan onderstaande velden in.<br><br>
                    
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col col-lg-2">
                    <label class="control-label"  for="input1">Aantal:</label>
                  </div>
                  <div class="col col-lg-10">
                    <input class="form-control" type="number" id="input1">
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col col-lg-2">
                    <label class="control-label"  for="input1">Welke fietsen:</label>
                  </div>
                  <div class="col col-lg-10">
                    <textarea class="form-control mt-3" id="input2" rows=5></textarea>
                  </div>
                </div>
              </span>
            `
            await Swal.fire({
              title: 'Breng je extra fietsen mee?',
              html: html,
              type: 'question',
              width: '600px',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Volgende',
              // cancelButtonColor: '#d33',
              // showCancelButton: true,
              // cancelButtonText: 'Nope',
              preConfirm:function(result){
                if(result){
                  // var amountofBikes = parseInt( ($('#input1').val()as string));
                  // var amountofBikes = parseInt(($('#input1').val() as HTMLInputElement).value)
                  var amountofBikes = parseInt( String($('#input1').val()) )
                  
                  var kindofBikes = $('#input2').val();
                  if (!amountofBikes){
                    amountofBikes = 0                                                                   
                  }
                  return {AmountOfNonStdBikes:amountofBikes, KindOfBikes:kindofBikes}  
                }
              }
            }).then((result) => {
                var res = {
                  SingleRoomAvailbe:selectedActivity.singleRoomAvailable,
                  AllowRemarks: selectedActivity.allowRemarks
                }
                // console.log("Result in [breng je extra fietsen mee in Else]", result);
                // console.log("res before [in de else] : ",res);
                var z = {...res,...result }

                // console.log("res after breng je extra fietsen mee? : ",z);
                this.changeSubscription(activity_id,z);
            });
          }
          // ------------------------------- Non Std Bikes -----------------------------------------------------
          else{
            this.changeSubscription(activity_id,{SingleRoomAvailbe:selectedActivity.singleRoomAvailable, AllowRemarks:selectedActivity.allowRemarks, OpenForPersonalTransport:selectedActivity.openForPersonalTransport, ExtraQuestion:selectedActivity.extraQuestion, ExtraQuestionText:selectedActivity.extraQuestionText });
          }
        }
      }
     
    } 
  }



  // askForInformation(){
  //   Swal.fire({
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Jep',
  //     cancelButtonText: 'Annuleren',
  //     title: 'Breng je niet leden mee?',
  //     html:  `<div style="text-align:left">
  //             <div class="row">
  //               <div class="col col-lg-12">
  //                 Als je niet leden meebrengt vul dan het aantal en de namen in de onderstaande velden in.<br><br>
  //                 Breng je niemand mee vul dan <strong>0</strong> in.
  //               </div>
  //             </div>
  //             <div class="row mt-4">
  //               <div class="col col-lg-2">
  //                 <label class="control-label"  for="input1">Aantal:</label>
  //               </div>
  //               <div class="col col-lg-10">
  //                 <input class="form-control" type="number" id="input1">
  //               </div>
  //             </div>
  //             <textarea class="form-control mt-3" id="input2" rows=5></textarea>
  //           </div> `,
  //     preConfirm:function(){
                      
  //                     var amount= parseInt( ($('#input1').val()as string));
  //                     var names= $('#input2').val();
  //                     if (!amount){
  //                          amount = 0                                                                   
  //                     }
  //                     return {amount:amount, names:names}
  //                 }
  //              })
  // }

  // swal.fire({
  //   showCancelButton:true,
    
  //   html:`input1:<input id="input1" type="text">
  //         input2: <input id="input2" type="text">
  //         input3: <input id="input3" type="text">`,
    
  //   preConfirm:function(){
  //                   in1= $('#input1').val();
  //                   in2= $('#input2').val();
  //                   in3 = $('#input3').val();
  //                   console.log(in1,in2,in3) // use user input value freely 
  //                        }
  //            })

//   `<div style="text-align:left">
//   <div class="row">
//     <div class="col col-lg-12">Breng je niet leden mee?</div>
//   </div>
//   <div class="row">
//     <div class="col col-lg-1">
//       <label class="control-label"  for="swal-input1">Aantal:</label>
//     </div>
//     <div class="col col-lg">
//       <input class="form-control" type="number" id="swal-input1">
//     </div>
//   </div>
//   <textarea  id="swal-input2" class="swal2-input"></textarea>
// </div> `

  private changeSubscription(activity_id: number, additionals?:{}){
    let singleRoomAvailable = false;
    let allowRemarks = false;
    let PersonalTransport = false;
    let ExtraQuestion = false;
    let ExtraQuestionText = "";

    // console.log("in ChangeSubscription [additionals]: ", additionals);

    if (typeof(additionals) !== "undefined"){
      if (additionals.hasOwnProperty('SingleRoomAvailbe')){
          singleRoomAvailable = (additionals as any).SingleRoomAvailbe;
      }
      if (additionals.hasOwnProperty('AllowRemarks')){
          allowRemarks = (additionals as any).AllowRemarks;
      }
      if (additionals.hasOwnProperty('OpenForPersonalTransport')){
        PersonalTransport = (additionals as any).PersonalTransport;
      }
      if (additionals.hasOwnProperty('ExtraQuestion')){
        ExtraQuestion = (additionals as any).ExtraQuestion;
      }
      if (additionals.hasOwnProperty('ExtraQuestionText')){
        ExtraQuestionText = (additionals as any).ExtraQuestionText;
      }
    }
    
    // console.log("ChangeSubscription: singleRoomAvailable, allowRemarks ",singleRoomAvailable, allowRemarks)

    var i = this.mySubs.find( (s:any) => s.subscriptionId == activity_id)
    if (i){
      Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je je wil uitschrijven?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.subscriptionService.toggleSingleMemberToSubscription(this.memberId, activity_id).subscribe( (res:any) => {
            if (res.status == 200){
              this.refreshMySubscriptions()
            }
          })
        }
      });
      
    }else{
      Swal.fire({
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope',
        type: 'warning',
        title: 'Ga je met ons mee?',
        html: this.getInnerHtmlForConfirmation(singleRoomAvailable, allowRemarks, ExtraQuestion, ExtraQuestionText),
        preConfirm:function(){    
          var singleRoom = $('#inputCheckbox').is(':checked');
          var remarks = $('#remarksTextArea').val();
          var extraQuestionResponse = $('#extraQuestionCheckbox').is(':checked');
          return {SingleRoom: singleRoom, Remarks: remarks,ExtraQuestionResponse:extraQuestionResponse}
        }
      }).then( (res:any)=>{
        if (res.value){
          
          if (typeof(additionals) !== "undefined"){
            if (!additionals.hasOwnProperty('SingleRoom')){
             (<any>additionals).SingleRoom = res.value.SingleRoom
            }

            if (!additionals.hasOwnProperty('ExtraQuestionResponse')){
              (<any>additionals).ExtraQuestionResponse = res.value.ExtraQuestionResponse
             }

            if (additionals.hasOwnProperty('ExtraQuestion')){
              ExtraQuestion = (additionals as any).ExtraQuestion;
            }

            if (!additionals.hasOwnProperty('OpenForPersonalTransport')){
              (<any>additionals).OpenForPersonalTransport = res.value.OpenForPersonalTransport;
            }
            if (!additionals.hasOwnProperty('Remarks')){
              (<any>additionals).Remarks = res.value.Remarks
             }

            if (additionals.hasOwnProperty('value')){
              if (!additionals.hasOwnProperty('AmountOfNonStdBikes')){
                (<any>additionals).AmountOfNonStdBikes = ( <any> additionals).value.AmountOfNonStdBikes
              }
              if (!additionals.hasOwnProperty('KindOfBikes')){
                (<any>additionals).KindOfBikes = ( <any> additionals).value.KindOfBikes
              }
            }

          }

          // console.log("Additionals send to server: ", additionals);
          
           this.subscriptionService.toggleSingleMemberToSubscription(this.memberId, activity_id, additionals).subscribe( (res:any) => {
            //  this.refreshMySubscriptions()
             var data = res.value;
             var paymentMetaData ={
              "Id": data.id,
              "Category": "eventdeposit",
              "idString": ""
            }
            this.paymentService.CreatePaymentLink(paymentMetaData).subscribe( (res:any) =>{
              // console.log(paymentMetaData)
              // console.log("link --> ")
              // console.log(res);
              var link = ""
              if (res.status == 200){
                link = res.value.url;
              }
              this.PaymentSummary(data.amount,data.titel, data.name, link );
            })
          })
        }     
      })
    }   
  }

  PaymentSummary(amount:number,titel: string, name:string, paymentlink: string){
    var innerHtml = ""
    if (amount > 0){
        innerHtml = `
                  <div class="text-left mt-5">
                    De inschrijving is gebeurd maar is pas volledig na de betaling van <strong>${amount}&euro;</strong> via<br>
                    <div class="mt-5">
                      <div class="mt-2 mb-2">Gebruik bij overschrijving de volgende gegevens:</div>
                      Rekening nummer: <strong>BE27-2300-2175-2773</strong><br>
                      Mededeling: <strong>${titel}-${name}</strong>
                    </div>
                    <br>
                    Deze gegevens ontvangt u ook nog per email.


                `
          if (paymentlink.length > 0){
            innerHtml +=`
                  <br><br>
                  of gebruik onderstaande link om dadelijk te betalen via Bancontact: <br><br>
            
                  <a href="${paymentlink}" target="_blank" onclick="Swal.closeModal();" ><img width='100' style='border: 1px solid black;' src='https://www.wringers-bertem.be/assets/images/bancontact/Bancontact.png' alt='bancontactlink'></a>


            
                  `
            }
                
        innerHtml += "</div>"
    }
    else{
      innerHtml = `
                <div class="text-left mt-5">
                  De inschrijving is gelukt, we zien je dan!
                </div>

      `
    }
    
    
    Swal.fire({
      title: "Samenvatting van de inschrijving.",
      html: innerHtml,
      width: '800px',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ok',
    }).then( (result) => {
          // this.router.navigate(['/home']);
          this.getMySubscriptions();
    })
  }

 
  refreshMySubscriptions(){
    // console.log("refreshMySubscriptions");
    
    this.getAllOpenSubscriptions();  
    // this.getMySubscriptions();
  }

  readDescription(id:number){
    var f = this.Subscriptions.find( (s:any) => s.id == id);
    // console.log("readDescription: ", f);
    
    var html = `  <div class="row mt-4">
                    <div class="col col-lg-4">
                      Beschrijving:
                    </div>
                    <div class="col col-lg-8 text-left">
                        ${f.description}
                    </div>
                  </div>`
    
    if (!f.noCostEvent){
      html +=`
                  <div class="row mt-4">
                    <div class="col col-lg-4">
                      Prijzen:
                    </div>
                    <div class="col col-lg-8">
              `
        if (f.prepaymentTarif > 0){
          html +=`
                      <div class="row" >
                        <div class="col col-lg-12 text-left">
                          Voorschot: ${f.prepaymentTarif}&euro;
                        </div>
                      </div>
                  `
        }
        if (f.normalTarif > 0){
            html +=`<div class="row mt-1" >
                      <div class="col col-lg-12 text-left">
                        Normale prijs: ${f.normalTarif}&euro;
                      </div>
                      </div>`
        }
        if (f.singleRoomAvailable){
          html +=` <div class="row mt-1">
                    <div class="col col-lg-12 text-left">
                      1-Persoonskamer prijs: ${f.onePersonTarif}&euro;
                    </div>
                  </div>`
                
        } 

        if (f.discountTarif > 0){
          html +=` <div class="row mt-1">
                    <div class="col col-lg-12 text-left">
                      Maximale korting: ${f.discountTarif}&euro;
                    </div>
                  </div>`
        } 
        
        html +=`</div>
                </div>`
    }
                  



    if (f){
      Swal.fire({
            title: "<Strong>Informatie</strong>",
            html: html,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Okay',
      });
    }
  }

  lockedClicked(){
    Swal.fire({
      type: 'info',
      title: 'Gesloten activiteit',
      text: 'Een gesloten activiteit kan alleen door het bestuur worden gewijzigd',
      confirmButtonText: 'Ok'
    })
  }

  ShowExtraInformation(id:number){
    
    var i = this.mySubs.find( (s:any) => s.subscriptionId == id);
    // console.log("showExtraInformation: ",i);
    
    var singleRoom = false;
    var personalTransport = false;
    var extraQuestionResponse = false;
    
    if (typeof (i) !== "undefined"){
      if (i.hasOwnProperty('singleRoom')){
        singleRoom = i.singleRoom;
      }
      if (i.hasOwnProperty('personalTransport')){
        personalTransport = i.personalTransport;
      }
      if (i.hasOwnProperty('extraQuestion')){
        extraQuestionResponse = i.extraQuestion;
      }
    }
    let innerHtml = ''
    if (i.extras > 0){
        innerHtml =  `<div class="row mt-2 text-left">
                        <div class="col col-lg-7">Aantal extras (niet leden):</div>
                        <div class="col col-lg-5">${i.extras}</div>
                      </div>
                      <div class="row mt-2 text-left">
                        <div class="col col-lg-7">Met de volgende namen:</div>
                        <div class="col col-lg-5"> ${i.extraNames}</div>
                      </div>
                      ` 
    }

    if(i.amountOfNonStdBikes > 0){
      innerHtml +=  `<div class="row mt-2 text-left">
                      <div class="col col-lg-7">Aantal MTB/electische fietsen:</div>
                      <div class="col col-lg-5">${i.amountOfNonStdBikes}</div>
                    </div>
                    <div class="row mt-2 text-left">
                      <div class="col col-lg-7">Type fietsen:</div>
                      <div class="col col-lg-5">${i.kindOfBikes}</div>
                    </div>
                    `
    }

    if ((i.remarks != null) && (i.remarks.length > 0)){
      innerHtml += `
                    <div class="row mt-2 text-left">
                      <div class="col col-lg-7">Opmerkingen:</div>
                      <div class="col col-lg-5">${i.remarks}</div>
                    </div>
      `
    }

    
    if (singleRoom){
      innerHtml += `<div class="row mt-4 text-left">
                      <div class="col col-lg-7">1-persoonskamer</div>
                      <div class="col col-lg-5">${ singleRoom ? 'ja' : 'nee'}</div>
                    </div>  
                    `
                      // <div class="col col-lg-12">1-persoonskamer gevraagd</div>
    }

    if (personalTransport){
      innerHtml += `<div class="row mt-2 text-left">
                      <div class="col col-lg-7">Eigen Vervoer</div>
                      <div class="col col-lg-5">${ personalTransport ? 'ja' : 'nee'}</div>
                    </div>  
                  `
      // <div class="col col-lg-12">Heeft eigen vervoer</div>
    }

    if (extraQuestionResponse){
      innerHtml += `<div class="row mt-2 text-left">
                      <div class="col col-lg-7">${i.subscription.extraQuestionText}</div>
                      <div class="col col-lg-5">${ i.extraQuestion ? 'ja' : 'nee'}</div>
                    </div>`
    }

    // else{
    //    innerHtml = '<div class="text-left">1-persoonskamer gevraagd</div>'
    // }

    Swal.fire({
      type: 'info',
      title: 'Ingeschreven extras',
      html: innerHtml ,
      width: '600px',
      confirmButtonText: 'Ok'
    })
  }

  private getInnerHtmlForConfirmation(singleRoomAvailable: boolean, allowRemarks: boolean, ExtraQuestion:boolean, ExtraQuestionText:string){
    let innerHtml =   `<div style="text-align:center">
                        <div class="row">
                          <div class="col">Wil je je inschijven op deze activiteit? </div>
                        </div>
                      `
    // console.log("get InnerHtmlforConfirmation singleRoomAvailable, allowRemarks: ",singleRoomAvailable, allowRemarks);
    
    if (singleRoomAvailable) {
      innerHtml += `  <div class="row mt-4">
                        <div class="col col-lg-2"></div>
                        <div class="col col-lg-2" style="text-align:right">
                          <input class="form-control" type="checkbox" id="inputCheckbox">
                        </div>
                        <div class="col col-lg-8" style="text-align:left">
                          <label class="control-label" for="input3" >Ik wil een 1-persoonskamer</label>
                        </div>
                      </div>
      `
    }

    if (allowRemarks){
      innerHtml +=`
      <div class="row mt-4">
        <div class="col col-lg-12 text-left">
          <div class="">
              <label for="remarksTextArea">Opmerkingen:</label>
              <textarea class="form-control" placeholder="" id="remarksTextArea" style="height: 130px"></textarea>
          </div>

        </div>
      </div>

      `
    }

    if (ExtraQuestion){
      innerHtml +=`
        <div class="row mt-4">
              <div class="col col-lg-2"></div>
              <div class="col col-lg-2" style="text-align:right">
                <input class="form-control" type="checkbox" id="extraQuestionCheckbox">
              </div>
              <div class="col col-lg-8" style="text-align:left">
                <label class="control-label"  for="extraQuestionCheckbox">${ExtraQuestionText}</label>
              </div>
            </div>
      `
    }

    innerHtml += '</div>'
    return innerHtml
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/subscription-activities-member/subscription-activities-member.component.ts